export default "__VITE_ASSET__398c41e1__"